const RING_GAP_DEGREES = 10;

const polarPoint = (centre: number, radius: number, degrees: number) => {
  const radians = ((degrees - 90) * Math.PI) / 180;
  return { x: centre + radius * Math.cos(radians), y: centre + radius * Math.sin(radians) };
};

export const ringArcPath = (centre: number, radius: number, fromDegrees: number, toDegrees: number): string => {
  const from = polarPoint(centre, radius, fromDegrees);
  const to = polarPoint(centre, radius, toDegrees);
  const largeArc = toDegrees - fromDegrees <= 180 ? "0" : "1";
  return `M ${from.x} ${from.y} A ${radius} ${radius} 0 ${largeArc} 1 ${to.x} ${to.y}`;
};

export const ringSegments = (centre: number, radius: number, total: number): string[] => {
  if (total <= 0) return [];

  const step = 360 / total;
  const sweep = step - RING_GAP_DEGREES;

  return Array.from({ length: total }, (_, index) => {
    const from = index * step + RING_GAP_DEGREES / 2;
    return ringArcPath(centre, radius, from, from + sweep);
  });
};

export const progressPercent = (done: number, active: number): number => (active ? (done / active) * 100 : 0);
